import api from '@/api/fetch'
import type { Config } from '@/types/config'

export function getConfig() {
  return api.get<Config>('/config').then(res => res.data)
}
